// @ts-nocheck
import React from 'react';

// Chevron is rendered through the .mov-select class which swaps the icon
// color for dark mode. Kept here as a Tailwind no-op for legacy callers.

/**
 * Select — native <select> styled to match the reference `.control` look.
 * For multi-select / typeahead use Combobox / Multiselect instead.
 */
const Select = React.forwardRef(({
  className = '',
  invalid,
  children,
  ...rest
}, ref) => (
  <select
    ref={ref}
    className={[
      'mov-select w-full bg-mov-paper-2 border rounded-md2 py-2.5 pl-3 pr-8 text-[13px] text-mov-ink',
      'outline-none appearance-none cursor-pointer',
      'transition-[border-color,box-shadow,background] duration-150',
      'mov-input-hover mov-textarea-focus',
      invalid ? 'mov-input-invalid' : 'border-mov-line-strong',
      className,
    ].join(' ')}
    {...rest}
  >
    {children}
  </select>
));
Select.displayName = 'Select';

export default Select;
